import React from "react";
import SvgIcon from "../SvgIcon";

export function Instagram({ color, size }) {
    return (
        <SvgIcon color={color} fontSize={size}>
            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.087 12.305a2.739 2.739 0 1 0 0-5.478 2.739 2.739 0 0 0 0 5.478" stroke="#446475" stroke-width="1.174" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.13 9.98c0 4.672-1.565 6.629-7.043 6.629s-7.042-1.565-7.042-7.043c0-5.086 1.565-7.042 7.042-7.042 5.87 0 7.043 1.956 7.043 7.456" stroke="#446475" stroke-width="1.174" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.609 6.045a.391.391 0 1 0 0-.783.391.391 0 0 0 0 .783" fill="#446475" stroke="#446475" stroke-width="1.174" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </SvgIcon>

    );
}